import React from 'react';
import { TextInput } from '../ui';

function TournamentEditView({
  tournamentEditForm,
  setTournamentEditForm,
  saveTournamentEdit,
  setEditingTournament,
  setView
}) {
  return (
    <section className="card auth-card">
      <h2 className="section-title">Edit Tournament</h2>
      <form onSubmit={saveTournamentEdit} className="auth-form">
        <TextInput
          label="Tournament Name"
          value={tournamentEditForm.name}
          onChange={(v) => setTournamentEditForm((s) => ({ ...s, name: v }))}
          placeholder="e.g., Spring Championship"
          required
        />
        <TextInput
          label="Location (Optional)"
          value={tournamentEditForm.location}
          onChange={(v) => setTournamentEditForm((s) => ({ ...s, location: v }))}
          placeholder="e.g., Community Center"
        />
        <TextInput
          type="date"
          label="Start Date (Optional)"
          value={tournamentEditForm.startDate}
          onChange={(v) => setTournamentEditForm((s) => ({ ...s, startDate: v }))}
        />
        <TextInput
          type="date"
          label="End Date (Optional)"
          value={tournamentEditForm.endDate}
          onChange={(v) => setTournamentEditForm((s) => ({ ...s, endDate: v }))}
        />
        <div>
          <label className="form-label">Notes (Optional)</label>
          <textarea
            value={tournamentEditForm.notes}
            onChange={(e) => setTournamentEditForm((s) => ({ ...s, notes: e.target.value }))}
            placeholder="Additional tournament details..."
            className="input"
            style={{
              width: "100%",
              resize: "vertical",
              minHeight: "80px"
            }}
          />
        </div>
        <div className="actions">
          <button
            className="btn btn-primary"
            type="submit"
          >
            Save Changes
          </button>
          <button
            className="btn btn-muted"
            type="button"
            onClick={() => {
              setEditingTournament(null);
              setView("season-detail");
            }}
          >
            Cancel
          </button>
        </div>
      </form>
    </section>
  );
}

export default TournamentEditView;
